import { supabase } from '../../../core/lib/supabase';

export interface ExecutionTemplateForChat {
  id: string;
  name: string;
  template_type: string | null;
}

/**
 * Linked execution templates for a workpill execution (same query as web
 * `getExecutionTemplatesByProjectId` — filters by workpill_execution_id).
 */
export async function fetchExecutionTemplatesForExecution(
  workpillExecutionId: string
): Promise<ExecutionTemplateForChat[]> {
  if (!workpillExecutionId) return [];

  const { data, error } = await supabase
    .from('workpill_execution_templates')
    .select(
      `
      id,
      name,
      templates:template_id (id, name, type)
    `
    )
    .eq('workpill_execution_id', workpillExecutionId);

  if (error) {
    console.warn('[executionTemplatesChatService]', error.message);
    return [];
  }

  return (data || []).map((et: Record<string, unknown>) => {
    const templates = et.templates as { name?: string; type?: string | null } | null;
    return {
      id: et.id as string,
      name: (et.name as string) ?? templates?.name ?? 'Unnamed',
      template_type: templates?.type ?? null,
    };
  });
}
